import type { IMenuSection } from "@fondationcss/ui";

export const menus: IMenuSection[] = [
  {
    title: 'Conformité',
    icon: 'shield-halved',
    iconOnly: true,
    groups: [
      { title: 'EFVP / Loi 25', icon: 'shield-halved', to: '/efvp' },
      { title: 'MCN', icon: 'lock', to: '/mcn' },
      { title: 'Archives', icon: 'box-archive', to: '/archives' },
      { title: 'CAI', icon: 'scale-balanced', to: '/cai' },
    ],
  },
  {
    title: 'Documents',
    icon: 'folder-tree',
    iconOnly: true,
    groups: [
      { title: 'Voûtes', icon: 'vault', to: '/doc/vaults' },
      { title: 'Gels légaux', icon: 'snowflake', to: '/doc/legal-holds' },
      { title: 'Dispositions', icon: 'gavel', to: '/doc/dispositions' },
      { title: 'Registre Loi 25', icon: 'user-shield', to: '/doc/privacy-registry' },
    ],
  },
  {
    title: 'Signatures',
    icon: 'signature',
    iconOnly: true,
    groups: [
      { title: 'Signatures', icon: 'file-signature', to: '/signatures' },
      { title: 'Ma bibliothèque', icon: 'draw-polygon', to: '/signatures/bibliotheque' },
    ],
  },
  {
    title: 'Administration',
    icon: 'sliders',
    iconOnly: true,
    groups: [
      { title: 'Voûtes (admin)', icon: 'vault', to: '/doc/admin/vaults' },
      { title: 'Sources de stockage', icon: 'database', to: '/doc/admin/storage-sources' },
      { title: 'Plans de classification', icon: 'sitemap', to: '/doc/admin/classification-plans' },
      { title: 'Règles de conservation', icon: 'clock', to: '/doc/admin/retention-rules' },
      { title: 'Types de documents', icon: 'file-lines', to: '/doc/admin/document-types' },
    ],
  },
]
